import { Chip } from '@mui/material';
import { useMemo } from 'react';

interface CoprocultivoSumaChipProps {
  ostertagia: number | null;
  trichostrongylus: number | null;
  cooperia: number | null;
  haemonchus: number | null;
  oesophagostomum: number | null;
  nematodirus: number | null;
}

export function CoprocultivoSumaChip({
  ostertagia,
  trichostrongylus,
  cooperia,
  haemonchus,
  oesophagostomum,
  nematodirus,
}: CoprocultivoSumaChipProps): JSX.Element {
  const suma = useMemo(
    () =>
      (ostertagia ?? 0) +
      (trichostrongylus ?? 0) +
      (cooperia ?? 0) +
      (haemonchus ?? 0) +
      (oesophagostomum ?? 0) +
      (nematodirus ?? 0),
    [ostertagia, trichostrongylus, cooperia, haemonchus, oesophagostomum, nematodirus],
  );

  const color: 'success' | 'info' | 'warning' =
    suma === 100 ? 'success' : suma === 0 ? 'info' : 'warning';

  const label =
    suma === 100
      ? 'Suma: 100% ✓'
      : suma === 0
      ? 'Negativo (sin parasitismo)'
      : `Suma: ${suma}% — debe ser 100 o 0`;

  return <Chip label={label} color={color} size="small" />;
}
